import React from "react";

function ShareResultButton({ todayDate, attemptsUsed, hintsUsed, par }) {
  const text = `Críptico - ${todayDate}\n` +
               `Acertou em ${attemptsUsed+1} tentativa${attemptsUsed > 0 ? "s" : ""}` +
               (hintsUsed > 0 ? ` com ${hintsUsed} dica${hintsUsed !== 1 ? "s" : ""}` : " sem usar dicas") + "\n" +
               (par ? `Par: ${par}\n` : "") +
               window.location.href;

  function isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

  async function handleShare() {
    if (navigator.share && isMobile()) {
      try {
        await navigator.share({ text });
      } catch (err) {
        console.error("Erro ao compartilhar:", err);
      }
    } else {
      try {
        await navigator.clipboard.writeText(text);
        alert("Resultado copiado para a área de transferência!");
      } catch (err) {
        console.error("Erro ao copiar:", err);
      }
    }
  }

  return (
    <button onClick={handleShare} className="button share-button">
      📤 Compartilhar resultado
    </button>
  );
}

export default ShareResultButton;
